import Theme from "../../constants/Theme";
import styled from "styled-components/macro";
import DotPayAccordion from "../../atoms/dotPayAccordion";
import Typography from "../../atoms/typography";
import { motion } from "framer-motion";

const FAQ = () => {
  return (
    <FAQStyling>
      <motion.div
        initial={{ y: 80, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 1 }}
        viewport={{ once: true }}
        className="container"
      >
        <Typography.Heading
          weight="medium"
          fontType="Galano Alt"
          className="faq__FAQStyling__faq-text-title"
          capitalize
          color="darkBlue"
          level={2}
        >
          Frequently asked questions
        </Typography.Heading>
        <DotPayAccordion
          data={[
            {
              title: "What is dotPay?",
              body: "Dotpay is an agency banking provider with a goal to help millions of underbanked Nigerians to access a secure and convenient banking",
            },
            {
              title: "How does Dotpay work?",
              body: "It works by making use of on an agent network where they use Dotpay terminals in their various locations, and provide financial services in their locations and its surroundings",
            },
            {
              title: "How can I get my device?",
              body: "If you register in the office, you’ll get it immediately. However, if you make a request for a device, it will be delivered to you by a courier service or an aggregator closest to you.",
            },
            {
              title: "How long does verification take?",
              body: "Verification takes 24 hours, but if registration is done in our office, you’ll be verified immediately",
            },
            {
              title: "How can I contact the support team?",
              body: "We are available to provide help and support everyday, throughout the week. You can call helpline 08061908723 Send us a whatsapp message on 08179456822, Twitter: dotpay_africa, Instagram: dotpay.africa, Facebook: dotpay dotpay",
            },
            {
              title: "Do you organise trainings for Agents?",
              body: "Yes, we organise training from time to time for agents to upskill and learn better ways to administer banking services to their customers.",
            },
            {
              title: "What services do we offer?",
              body: "We offer all regular bank services such as card withdrawal, funds transfer, bills payment, airtime vending, etc.",
            },
          ]}
        />
      </motion.div>
    </FAQStyling>
  );
};
const FAQStyling = styled.div`
  padding: 80px 0px;
  .faq__FAQStyling {
    &__faq-text-title {
      font-size: 20px;
      padding: 20px 0;
      @media screen and (min-width: 768px) {
        font-size: ${Theme.fontSizes.xextralarge};
        text-align: center;
        padding-bottom: 32px;
      }
    }
  }
`;
export default FAQ;
